module.exports = __webpack_public_path__ + "img/branch-particle-02.5e773a4a.png";